import { createReducer, on } from '@ngrx/store';
import * as fromGameActions from '../actions/game.action';
export const featureKey = 'game';

export interface State {
    casualGames: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    casualGames: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromGameActions.getCasualGamesSuccess, (state: State, props: any) => ({
        ...state,
        casualGames: { data: props.data, isLoaded: true },
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);